import { Button, Center, Heading, Text } from '@chakra-ui/react'
import { useRouter } from 'next/router'

const ErrorPageFormat = (message: string, statusCode: number = 500) => {
  const router = useRouter()

  return (
    <>
      <Center w="100%" h="90vh" flexDir={'column'} gap="10">
        <Center gap="3" flexDir={'column'}>
          <Heading>{statusCode} Error</Heading>
          <Text color="gray.400">{message}</Text>
        </Center>
        <Button
          colorScheme={'gray'}
          size="lg"
          onClick={(e) => {
            e.preventDefault()
            router.push('/')
          }}
        >
          ホーム
        </Button>
      </Center>
    </>
  )
}

const getErrorMessage = (statusCode: number): string => {
  switch (statusCode) {
    case 403:
      return 'アクセス権限がありません'
    case 404:
      return 'お探しのページは見つかりませんでした'
    default:
      return `${statusCode} エラーが発生しました`
  }
}

import * as Sentry from '@sentry/react'

const ErrorPage = ({
  statusCode,
  error,
}: {
  statusCode?: number
  error?: any
}) => {
  if (statusCode) {
    return ErrorPageFormat(getErrorMessage(statusCode), statusCode)
  }
  if (error) {
    Sentry.captureException(error)
    return ErrorPageFormat(error.message)
  }

  return ErrorPageFormat('クライアントエラー', 500)
}

export default ErrorPage
